"use strict";

export default {
  get forceTouchAvailable() {
    return false;
  }
};
//# sourceMappingURL=PlatformConstants.web.js.map